import { FunctionalComponent } from 'preact';
import { Suspense, lazy } from 'preact/compat';
import { useSelector } from 'react-redux';

import { selectUiMode } from '../../store/selectors';

const Content = lazy(() => import('./Content'));

const Friends: FunctionalComponent = () => {
  const uiMode = useSelector(selectUiMode);

  return (uiMode === 'focus' || typeof window === 'undefined') ? null : (
    <Suspense fallback={null}>
      <Content />
    </Suspense>
  );
};

export default Friends;
